import React, {Fragment} from 'react';

import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import styled from 'styled-components';

import {gt} from 'app/utils/i18n';

import {OrderableStep} from './OrderableStep';

import type {ProcessContentFieldArrayType} from 'app/process/types';
type Props = {
  content: ProcessContentFieldArrayType;
  toggleReorderMode: () => void;
  onReorder: (sourceIdx: number, targetIdx: number) => void;
};
export function OrderableStepsList({
  content,
  onReorder,
  toggleReorderMode,
}: Props) {
  return (
    <Fragment>
      <StyledHeaderDiv>
        <div className="mr-2 icon-container">
          <i className="fa fa-fw fa-sort" />
        </div>
        <div className="flex-grow-1">
          <h5>{gt('Moving Steps')}</h5>
          <div>{gt('Drag and drop the steps to reorder them.')}</div>
        </div>
        <button className="btn btn-light" onClick={toggleReorderMode}>
          {gt('Done')}
        </button>
      </StyledHeaderDiv>

      <DragDropContext
        onDragEnd={(result) => {
          // dropped outside the list
          if (!result.destination) {
            return;
          }

          onReorder(result.source.index, result.destination.index);
        }}
      >
        <Droppable droppableId="droppable">
          {(provided) => (
            <ol
              className="list-unstyled"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {content.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <OrderableStep step={item} />
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ol>
          )}
        </Droppable>
      </DragDropContext>
    </Fragment>
  );
}
const StyledHeaderDiv = styled.div.attrs({
  className: 'py-3 px-2 d-flex align-items-center',
})`
  background-color: #e5f7e6;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);

  .icon-container {
    font-size: 2rem;
  }

  h5 {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
`;
